import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import Accordion from '../accordion';
import { jetBlack } from '../colors';
import DefaultTheme from './theme';
export var ProcessAccordionTheme = DefaultTheme;
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';
import type { JsxPanel } from '../accordion';

export type ProcessAccordionEntry = {|
  iconUrl?: string;
  iconAlt?: string;
  accentColor?: string;
  title: string;
  content: Node;
|}

export type Props = {|
  startIconUrl?: string;
  startIconAlt?: string;
  endIconUrl?: string;
  endIconAlt?: string;
  entries: ProcessAccordionEntry[],
  rest?: any,
|}
*/

var ProcessAccordion = function ProcessAccordion(_ref
/*: Props */
) {
  var startIconUrl = _ref.startIconUrl,
      startIconAlt = _ref.startIconAlt,
      endIconUrl = _ref.endIconUrl,
      endIconAlt = _ref.endIconAlt,
      _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["startIconUrl", "startIconAlt", "endIconUrl", "endIconAlt", "entries", "theme"]);

  var jsxPanels
  /*: JsxPanel[] */
  = entries.map(function (entry) {
    return {
      head: /*#__PURE__*/React.createElement(theme.Panel.Head, {
        color: entry.accentColor || jetBlack()
      }, /*#__PURE__*/React.createElement(theme.Panel.ProcessIcon, {
        src: entry.iconUrl,
        alt: entry.iconAlt,
        loading: "lazy"
      }), entry.title, /*#__PURE__*/React.createElement(theme.Panel.ArrowIcon, {
        width: 3.2,
        color: jetBlack()
      })),
      body: /*#__PURE__*/React.createElement(theme.Panel.Body, null, entry.content)
    };
  });
  return /*#__PURE__*/React.createElement(theme.Main, null, /*#__PURE__*/React.createElement(theme.SidePadding, null, /*#__PURE__*/React.createElement(theme.ProcessStartIcon, {
    src: startIconUrl,
    alt: startIconAlt,
    loading: "lazy"
  })), /*#__PURE__*/React.createElement(Accordion, Object.assign({
    jsxPanels: jsxPanels,
    theme: theme.AccordionTheme
  }, rest)), /*#__PURE__*/React.createElement(theme.SidePadding, null, /*#__PURE__*/React.createElement(theme.ProcessEndIcon, {
    src: endIconUrl,
    alt: endIconAlt,
    loading: "lazy"
  })));
};

export default ProcessAccordion;